import { ReactNode } from 'react';
import classNames from 'classnames';

import Typography from '@components/atoms/Typography';

import classes from './TextContainer.module.scss';

type Props = {
  className?: string;
  children: ReactNode;
};

const TextContainer = ({ className, children }: Props): JSX.Element => (
  <div className={classNames(classes.wrapper, className)}>
    <Typography renderAs="p" variant="h4">
      {children}
    </Typography>
  </div>
);

export default TextContainer;
